module.exports = __webpack_public_path__ + "static/img/J_pikes.8dda08d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/J_pikes.svg
// module id = dRGx
// module chunks = 1